/**
 * Controla el diálogo de rechazar tarea.
 */
CostesEditModalCtrl.$inject = ['$log', '$scope', '$http'];

export default function CostesEditModalCtrl($log, $scope, $http) {
    var cem = this;

    cem.costes = $scope.model.costes;
    cem.tareaId = $scope.model.tareaId;
    cem.dialogHandler = $scope.dialog;
    cem.cargando = {
        datos: false,
        submit: false
    };
    cem.formDeshabilitado = false;
    // console.log(cem.costes.values);
    // console.log(cem.costes.allOptions);
    cem.opcionesDisponibles = [];

    cem.cantidadAnyadir = 1;


    cem.calculaPrecio = function (coste) {
        if (!cem.isNumber(coste.units)) return "";
        return (coste.price * coste.units).toFixed(2);
    };

    cem.calcularOpcionesDisponibles = function () {
        var opcionesTemp = [];
        cem.costes.allOptions.forEach(function (option) {
            var exists = cem.costes.values.some(function (option2) {
                if (option2.codigo == option.codigo)
                    return true;
            });
            if (!exists)
                opcionesTemp.push(option);
        });

        // console.log(opcionesTemp);
        cem.opcionesDisponibles = opcionesTemp;
        articuloPorDefecto();
    };

    cem.calcularOpcionesDisponibles();

    cem.calculaPrecioAnyadir = function () {
        if (cem.articuloSeleccionado == null) return 0;
        if (!cem.isNumber(cem.cantidadAnyadir)) return "";

        return (cem.articuloSeleccionado.price * cem.cantidadAnyadir).toFixed(2);
    };

    cem.eliminarArticulo = function (index) {
        cem.costes.values.splice(index, 1);
        cem.calcularOpcionesDisponibles();
    };

    cem.anyadirArticulo = function () {
        if (cem.articuloSeleccionado == null) return;
        if (!cem.isNumber(cem.cantidadAnyadir)) return;

        cem.costes.values.push(
            {
                "codigo": cem.articuloSeleccionado.codigo,
                "descripcion": cem.articuloSeleccionado.descripcion,
                "units": cem.cantidadAnyadir,
                "price": cem.articuloSeleccionado.price
            }
        );
        cem.cantidadAnyadir = 1;
        articuloPorDefecto();
        cem.calcularOpcionesDisponibles();
    };

    cem.costeTotal = function () {
        var total = 0;
        for (var i = 0; i < cem.costes.values.length; i++)
            total += cem.costes.values[i].price * cem.costes.values[i].units;
        return total;
    };

    function articuloPorDefecto() {
        cem.articuloSeleccionado = isArray(cem.opcionesDisponibles) && cem.opcionesDisponibles.length > 0
            ? cem.opcionesDisponibles[0]
            : null;
    }

    function editarCostes(costes, tareaId) {
        cem.cargando.submit = true;
        cem.formDeshabilitado = true;

        var params = {
            prefijo: costes.prefix,
            costes: costes.values
        };
        var url = Sigo.var.path + '/api/v1/tareas/' + tareaId + '/costes';

        var promise = $http.post(url, params);

        promise.then(function (data) {
            Sigo.UI.Toast.success('', Lang.get('mensajes.msg_costes_actualizados'));
            cem.cargando.submit = false;
            cem.formDeshabilitado = false;
        }, function (err) {
            Sigo.UI.Messages.open([err.data.message], 0);
            cem.cargando.submit = false;
            cem.formDeshabilitado = false;
        });

        return promise;
    }

    cem.submit = function (costes, tareaId) {
        editarCostes(costes, tareaId).then(function () {
            cem.dialogHandler.close(costes);
        });
    };

    cem.cancelar = function () {
        cem.dialogHandler.cancel();
    };

    cem.isNumber = function (number) {
        return number !== null && typeof number !== "undefined" && !isNaN(number) && angular.isNumber(+number);
    };
}